export enum TopNavFor {
	ACCOUNT = 'ACCOUNT',
	ENTRIES_AND_REWARDS = 'ENTRIES_AND_REWARDS',
	FACILITY_SCAN_HISTORY = 'FACILITY_SCAN_HISTORY',
}
